import React from "react";
import "../styles/eight.css";

const InvestInKnowledge = () => {
  return (
    <section className="invest-section mb-0">
      <div className="invest-container">
        {/* Row containing both columns */}
        <div className="invest-row">
          {/* Left Column - Text Section */}
          <div className="invest-col text-section">
            <h2>
              Invest in Knowledge Today{" "}
              <span>To shape a brighter, successful tomorrow,</span>
              Empowering Your Future{" "}
              <span>through learning and growth.</span>
            </h2>
            <p>
              Our cutting-edge E-Learning Programs are meticulously designed to empower you with
              in-demand skills, unlocking limitless opportunities for high-paying careers across
              multiple industries and setting you on the path to success.
            </p>
            <button className="contact-button" href="/contact">Contact</button>
            <div className="stats">
              <div className="stat-item">
                <h2>50+</h2>
                <p>Career Courses</p>
              </div>
              <div className="stat-item">
                <h2>#1</h2>
                <p>Top Industry Trainers</p>
              </div>
              <div className="stat-item">
                <h2>#1</h2>
                <p>Top IIT Alumnus</p>
              </div>
            </div>
            <div className="stats">
              <div className="stat-item">
                <h2>200 + Projects</h2>
                <p>Real Time Based Intensive Programs from IITians</p>
              </div>

            </div>
          </div>
          
          {/* Right Column - Courses Section */}
          <div className="invest-col browse-section">
            <h2>Browse Top Essential Career Courses</h2>
            <div className="course-grid">
              <div className="course-item uiux"><p>UI/UX Design AI-Agents & Quantum Apps</p></div>
              <div className="course-item webdev"><p>Web 3.0 Development</p></div>
              <div className="course-item marketing"><p>Digital Marketing</p></div>
              <div className="course-item practical"><p>Practical Learning</p></div>
              <div className="course-item dsa"><p>Data Structures & Algorithms</p></div>
              <div className="course-item quantum"><p>Quantum Computing</p></div>
              <div className="course-item ai"><p>Artificial Intelligence</p></div>
              <div className="course-item ml"><p>Machine Learning</p></div>
              <div className="course-item cybersecurity"><p>Cybersecurity</p></div>
              <div className="course-item aiagents"><p>AI Agents</p></div>
              <div className="course-item aiengineer"><p>AI & ML Engineer</p></div>
              <div className="course-item blockchain"><p>Blockchain</p></div>
              <div className="course-item geology"><p>GeoSciences & Geo-AI</p></div>
              <div className="course-item environment"><p>Env. Sciecnces & Energy </p></div>
              <div className="course-item other"><p>More Demand Courses</p></div>
            </div>
            <button className="browse-all" href="/enroll">Enroll Course Today</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestInKnowledge;